<template lang="pug">
  #member-center
    router-view
</template>

<script>
export default {
  name: "MemberCenter"
};
</script>

<style lang="sass" scoped></style>
